const programmingProfiles = [
    {
        id: 3,
        name: 'HackerRank',
        imageUrl: 'img/hack.svg',
        link: 'https://www.hackerrank.com/bhyeanhasan',
        altText: 'HackerRank Profile',
    },
    {
        id: 2,
        name: 'LeetCode',
        imageUrl: 'https://cdn.iconscout.com/icon/free/png-256/free-leetcode-3521542-2944960.png?f=webp',
        link: 'https://leetcode.com/bhyeanhasan/',
        altText: 'LeetCode Profile',
    },
    {
        id: 1,
        name: 'Codeforces',
        imageUrl: 'https://iili.io/oT0jj9.png',
        link: 'https://codeforces.com/profile/bhyean',
        altText: 'Codeforces Profile',
    },
    {
        id: 4,
        name: 'URI',
        imageUrl: 'https://iili.io/oT0WpS.png',
        link: 'https://www.urionlinejudge.com.br/judge/en/profile/312468',
        altText: 'URI Profile',
    },
];

export default programmingProfiles;
